import {
  FontIcons,
  HoverTooltip,
  IconButton,
  IconButtonProps,
  TooltipPositions
} from '@brandfolder/react';
import { FunctionComponent } from 'react';
import styled from 'styled-components';

interface AsideButtonProps extends IconButtonProps {
  icon: FontIcons;
  label: string;
  open: boolean;
  setOpen: (open: boolean) => void;
  tooltip: string;
}

const UnstyledAsideButton: FunctionComponent<AsideButtonProps> = (props) => {
  const { className, icon, label, open, setOpen, tooltip, ...otherProps } = props;

  return (
    <HoverTooltip className={className} position={TooltipPositions.Right} text={tooltip}>
      <IconButton
        {...otherProps}
        icon={icon}
        iconProps={{ iconSize: 15 }}
        label={label}
        onClick={() => setOpen(!open)}
      />
    </HoverTooltip>
  );
};

const StyledAsideButton = styled(UnstyledAsideButton)`
  &:after {
    z-index: 2;
  }

  &:before {
    background-color: #111;
    font-size: 12px;
    line-height: 18px;
    padding: 6px 8px;
  }

  .bf-button__icon {
    background-color: #333;
    border-color: #333;
    color: #fff;
    height: 45px;
    min-height: 0;
    width: 45px;

    &:hover {
      background-color: #111;
      border-color: #111;
      color: #fff;
    }

    &:active {
      background-color: #111;
      border-color: #111;
      color: #fff;
    }

    &:focus-visible {
      background-color: #111;
      border-color: #111;
      color: #fff;
      outline-color: #999;
    }
  }
`;

export const AsideButton: FunctionComponent<AsideButtonProps> = (props) => {
  return <StyledAsideButton {...props} />;
};
